import Vue from 'vue'
import axios from 'axios'
import storage from 'good-storage'
import { notification } from 'ant-design-vue'
import { ERR_OK, LOGIN_EXPIRED } from 'config/index'
import { LENGJ_ERR_OK } from 'config/lengj-index'
import router from '../router'
import downloadDocument from './downloadDocument'
import manualUpload from './manualUpload'

Vue.use(notification)
const request = (isErrorPrompt = true) => {
  // 局部拦截器
  const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 120000,
  })

  service.interceptors.request.use(
    config => {
      const { url, data, method, headers, responseType } = config
      //下载请求超时时间延迟
      if (responseType && responseType === 'blob') {
        if (url === 'customer/file/batchExport') {
          config.timeout = 0 //(no timeout)
        } else {
          config.timeout = 120000
        }
      }
      // 信用审批管理-全部查询-审批列表，timeout不做限制
      if (url === 'bp/apply/page') {
        config.timeout = 0 // no timeout
      }

      // 排除login接口
      if (url !== '/login') {
        config.headers.token =
          (storage.get('userInfo') && storage.get('userInfo').token) || ''
      }

      // 把value为undefined转换为""
      if (data) {
        for (const configKey in data) {
          if (data[configKey] == null) {
            config.data[configKey] = ''
          }
        }
      }

      // 处理手动上传
      const uploadData = manualUpload({ method, headers, data })
      if (uploadData) {
        config.data = uploadData
      }

      return config
    },
    err => {
      console.log('request_err', err)
    },
  )

  service.interceptors.response.use(
    response => {
      // 拦截下载，如果返回的是二进制文件流，会直接下载
      // todo 这里可能还需要处理一下预览的问题
      if (!downloadDocument(response)) {
        return
      }
      //棱镜接口
      if (response.config && response.config.url.indexOf('riskraider') != -1) {
        var { resultCode, resultMsg, resultData } = response.data

        if (resultCode !== LENGJ_ERR_OK) {
          if (!isErrorPrompt) {
            return { resultCode, resultMsg, resultData }
          }
          notification.error({
            message: '提示',
            description: resultMsg || '操作失败',
          })
          return Promise.reject(resultMsg)
        }
        return { resultCode, resultMsg, resultData }
      } else {
        //内部接口
        var { code, message, data } = response.data
        // 登录过期
        if (code === LOGIN_EXPIRED) {
          router.push({
            name: 'login',
            query: {
              redirect: router.app.$route.name,
            },
          })
          storage.clear()
          if (isErrorPrompt) {
            notification.error({
              key: 'login',
              message: '提示',
              description: message,
            })
          }
          return Promise.reject(message)
        }

        if (code !== ERR_OK) {
          if (!isErrorPrompt) {
            return { message, data, code }
          }
          notification.error({
            message: '提示',
            description: message || '操作失败',
          })
          return Promise.reject(message)
        }
        return { message, data, code }
      }
    },
    err => {
      console.log('response_err', err)
      let desc = ''
      err.toString().includes('timeout')
        ? (desc = '超时了,请重新尝试！')
        : err.toString()
      console.log(err)
      notification.error({
        message: '提示',
        description: desc,
      })
    },
  )

  return service
}

export default request
